<script setup>
import {defineProps} from "vue";

const props = defineProps({
    modelValue: String,
});
</script>

<template>
    <div class="lg:w-1/3 flex items-center rounded-full border border-gray-500 px-4 py-2">
        <div class="flex items-center flex-1 space-x-2 rtl:space-x-reverse">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                 stroke="currentColor" class="h-6 w-6 stroke-gray-600 rtl:border-r rtl:border-transparent rtl:border-2">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
            </svg>
            <input type="text" :value="props.modelValue" @input="$emit('update:modelValue', $event.target.value)"
                   :placeholder="$tt('library_page_search_placeholder')"
                   class="text-gray-600 placeholder-gray-400 flex-1 h-10 font-medium outline-none bg-transparent"/>
        </div>
    </div>
</template>

